import IRawContact from '@app/types/base/IRawContact';

export default class MarketRestrictionUtil {
	public static mapMarketsObjectToArray(markets?: Record<string, boolean>): string[] {
		return Object.keys(markets || {}).filter(market => markets && markets[market]);
	}

	/**
	 * Checks if a given contact applies to a set of market restrictions
	 *
	 * Access granted:
	 * - if no market restriction is set on slide
	 * - if slide market restrictions and primary contact markets overlap
	 *
	 * @param contact
	 * @param marketRestrictions
	 */
	public static contactSatisfiesMarketRestrictions(
		contact?: IRawContact,
		marketRestrictions?: Record<string, boolean> | string[]
	): boolean {
		const allowedMarketList: string[] = Array.isArray(marketRestrictions)
			? marketRestrictions
			: MarketRestrictionUtil.mapMarketsObjectToArray(marketRestrictions);
		const contactMarketsList: string[] = contact ? contact.markets || [] : [];

		// access granted:
		// - if no market restriction is set on slide
		// - if slide market restrictions and primary contact markets overlap
		return (
			!allowedMarketList.length ||
			allowedMarketList.some((market: string): boolean => contactMarketsList.includes(market))
		);
	}
}
